module.exports = __webpack_public_path__ + "img/comingsoon-bg.f7dd69c5.jpg";